import "./BrandTitle.scss";
import { colorOptions } from "../../utils/colors";

function BrandTitle({ fontSize = 25, className = "" }) {
  return (
    <span
      className={`brand-title ${className}`}
      style={{ fontSize: `${fontSize}px` }}
    >
      <span className="brand-color-1" style={{ color: colorOptions[13] }}>
        SO
      </span>
      <span className="brand-color-2" style={{ color: colorOptions[12] }}>
        MI
      </span>
      <span className="brand-color-3" style={{ color: colorOptions[2] }}>
        GO
      </span>
      <span className="brand-color-4" style={{ color: "white" }}>
        .io
      </span>
    </span>
  );
}

export default BrandTitle;
